import React from "react";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import moment from "moment";

import ReportPaymentsInvoices from "../../../validations/ReportPaymentsInvoices";
import { ReportOperatorSalary } from "../../../models/ReportOperatorSalary";

import axiosClient from "../../../config/axios";

import OrdersPaymentsForm from "../../../forms/ordersPaymentsForm";
import TableOrderPayment from "../../../components/reports/TableOrderPayments";
import Loader from "../../../components/loader";

const OrdersPayments = () => {
  const [loading, setLoading] = React.useState(true);
  const [records, setRecords] = React.useState([]);
  const [orders, setOrders] = React.useState([]);
  const [payments, setPayments] = React.useState([]);

  const [status, setStatus] = React.useState([]);
  const [paymentTypes, setPaymentTypes] = React.useState([]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      ...ReportOperatorSalary(),
      paymentTypes: "all",
      companyType: "all",
    },
    validationSchema: ReportPaymentsInvoices,

    onSubmit: async (values) => {
      setLoading(true);
      try {
        const paymentStart = values.start
          ? moment(values.start).format("YYYY-MM-DD")
          : "";
        const paymentEnd = values.end
          ? moment(values.end).format("YYYY-MM-DD")
          : "";
        const paymentType = values.paymentTypes || "all";
        const companyType = values.companyType || "all";

        const endpoint = `/reports/payments?paymentStart=${paymentStart}&paymentEnd=${paymentEnd}&paymentTypeFilterCode=${paymentType}&payment_disabled=false&companyType=${companyType}`;
        const { data } = await axiosClient.get(endpoint);

        const payments = data?.payments || [];

        // Ordenar por fecha de pago
        payments.sort(
          (a, b) => new Date(a.payment_date) - new Date(b.payment_date)
        );

        setRecords(payments);
        setOrders(payments);
        setPayments(payments);

      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    },
  });

  const fetchData = async () => {
    try {
      // Fetch statuses
      const responseStatus = await axiosClient.get(
        "/orderStatuses/allWithOrderCount"
      );
      const formattedOptionsStatus = [
        { value: "all", label: "Todas las opciones" },
        ...responseStatus.data.data.map((operator) => ({
          label: operator.order_status,
          value: operator.order_status,
        })),
      ];
      setStatus(formattedOptionsStatus);

      // Fetch payment types
      const responsePaymentTypes = await axiosClient.get("/paymentTypes/all");
      const formattedPaymentTypes = [
        { value: "all", label: "TODOS" },
        ...responsePaymentTypes.data.data.map((pt) => ({
          label: pt.payment_type_name,
          value: pt.payment_type_code,
        })),
      ];

      setPaymentTypes(formattedPaymentTypes);
    } catch (error) {
      console.error(error);
    }
  };

  React.useEffect(() => {
    formik.handleSubmit();
    fetchData();
  }, []);

  return (
    <React.Fragment>
      <Loader isLoading={loading} />
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Inicio</Link>
            </li>
            <li className="breadcrumb-item active">Reporte de pagos</li>
          </ol>
          <h1 className="page-header mb-0">Reporte de pagos</h1>
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-xl-12 card border-0 p-3">
          <OrdersPaymentsForm
            formik={formik}
            records={records}
            status={status}
            paymentTypes={paymentTypes}
            payments={payments}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12 card border-0 p-3">
          <TableOrderPayment
            orders={orders}
            payments={payments}
            start={formik.values.start}
            end={formik.values.end}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default OrdersPayments;
